import React from "react";
import { useQuery } from "@apollo/client";
import { CasesCredentialVerificationCaseInfoHeaderContainerCredentialVerificationCaseV1Document } from "../../../../../../generated";
import { CaseInfoHeader, CaseInfoHeaderFields } from "../../../../../shared/case-info-header/case-info-header";
import { ComponentQueryLoader } from "../../../../../shared/component-query-loader";

interface CaseInfoHeaderContainerProps {
  caseId: string;
}

export const CaseInfoHeaderContainer: React.FC<CaseInfoHeaderContainerProps> = (
  props
) => {
  const {
    data: applicantDetailData,
    loading: applicantDetailLoading,
    error: applicantDetailError,
  } = useQuery(CasesCredentialVerificationCaseInfoHeaderContainerCredentialVerificationCaseV1Document, {
    variables: {
      credentialVerificationCaseV1Id: props?.caseId,
    },
    context: {
      headers: {
        "cache-enabled": "true",
      }
    }
  });

  const caseInfoData: CaseInfoHeaderFields = {
    applicant: {
      displayName: applicantDetailData?.credentialVerificationCaseV1?.applicant?.displayName ?? "",
      id: applicantDetailData?.credentialVerificationCaseV1?.applicant?.id ?? "",
    },
    submittedAt: applicantDetailData?.credentialVerificationCaseV1?.submittedAt ?? "",
    lastActivityAt: applicantDetailData?.credentialVerificationCaseV1?.lastActivityAt ?? "",
    expirationEligibleAt: applicantDetailData?.credentialVerificationCaseV1?.expirationEligibleAt ?? "",
    id: applicantDetailData?.credentialVerificationCaseV1?.id
  }

  return (
    <ComponentQueryLoader
      loading={applicantDetailLoading}
      hasData={applicantDetailData}
      error={applicantDetailError}
      hasDataComponent={
        <CaseInfoHeader
          data={caseInfoData} caseType="credentialVerification"
        />
      }
    />
  );
};
